"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

// import PHOTO_SET from '../../data/galleryItems/galleryItems';


var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _components = require("components");

var _PageTitleWithBackground = require("@quixeltools/quixel-ui-library/dist/components/common/website/PageTitleWithBackground");

var _PageTitleWithBackground2 = _interopRequireDefault(_PageTitleWithBackground);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _CategoryFilter = require("@quixeltools/quixel-ui-library/dist/components/common/website/CategoryFilter");

var _CategoryFilter2 = _interopRequireDefault(_CategoryFilter);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Hero = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _gallery = require("redux/modules/gallery");

var _components2 = require("../../components");

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cf = function cf(path) {
  return __CLIENT__ && "https://d3uwib8iif8w1p.cloudfront.net/megascans/" + path || "";
};
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};
var cloudfront = function cloudfront(path) {
  return __CLIENT__ && "https://d3uwib8iif8w1p.cloudfront.net/quixel/" + path || "";
};

var windowWidth = void 0;

var loadingSpinnerStyles = (0, _glamor.css)({
  textAlign: "center",
  padding: "50px"
});

var galleryStyles = (0, _glamor.css)({
  position: "relative",
  transform: "translateZ(0)"
});

var tileStyles = (0, _glamor.css)({
  height: "100%",

  float: "left",
  position: "absolute",
  cursor: "pointer",
  transition: "transform 0.4s",
  transform: "translateZ(0)",
  display: "table",
  background: "#000",
  "& > img": {
    maxHeight: "100%",
    height: "100%",
    width: "100%",
    transition: "all 0.2s ease-out",
    background: "#000"
  },
  "&:hover": {
    zIndex: 1,
    "& > img": {
      transform: "scale(1.05, 1.05)"
    },
    "& > div": {
      transform: "scale(1.05, 1.05)",
      opacity: "1"
    }
  }
});

var imageDescStyles = function imageDescStyles(fontScale) {
  return (0, _glamor.css)({
    opacity: "0",
    color: "#fff",
    position: "absolute",
    top: "0px",
    left: "0px",
    padding: "1.2vw",
    background: "rgba(0,0,0,0.5)",
    width: "100%",
    height: "100%",
    transition: "all 0.2s ease-out",

    "& > div:nth-child(1)": {
      fontSize: (0, _css.unitRem)(0.6 * fontScale),
      whiteSpace: "nowrap",
      overflow: "hidden",
      paddingBottom: "5px",
      textOverflow: "ellipsis"
    },
    "& > div:nth-child(2)": {
      fontSize: (0, _css.unitRem)(0.45 * fontScale),
      color: "#ccc"
    },
    "& > div:nth-child(3)": {
      padding: "15px 0px",
      fontSize: "12px",
      color: "#bbb",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textTransform: "uppercase"
    }
  });
};

var messageBelowStyles = (0, _glamor.css)({
  textAlign: "center",
  padding: "5.8em",
  background: "#121212",
  "& > h1": {
    paddingBottom: "0.85em"
  },
  "& > span": {
    lineHeight: "1.5em"
  },
  "& > a": {
    fontSize: "1.125em"
  }
});
var smallHeading = (0, _glamor.css)({
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  letterSpacing: "0.9px",
  fontSize: "1rem",
  //marginTop: '9.34rem',
  //paddingTop: '9rem',
  marginBottom: "1.9rem",
  fontWeight: "700",
  //color: 'gray',
  textAlign: "center",
  maxWidth: "630px",
  color: "#6f6f6f"
}, (0, _css.maxWidth)(_css.breakpoints.large)({
  display: "flex",
  justifyContent: "center"
}));
var sendUs = (0, _glamor.css)({
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  letterSpacing: "-0.6px",

  //marginTop: '9.34rem',
  //paddingTop: '9rem',
  marginBottom: "2.8rem",
  fontWeight: "400",
  //color: 'gray',
  textAlign: "center",
  maxWidth: "630px",
  color: "#808080",
  fontSize: "1.6rem"
}, (0, _css.maxWidth)(_css.breakpoints.large)({
  display: "flex",
  justifyContent: "center"
}), (0, _css.maxWidth)(_css.breakpoints.super4k)({
  fontSize: "1.5rem"
}), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
  fontSize: "1.4rem"
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  fontSize: "1.3rem"
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  fontSize: "1.3rem"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  fontSize: "1.2rem"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  fontSize: "1rem"
}));
var Heading = (0, _glamor.css)({
  display: "block",
  color: "#ffffff",
  letterSpacing: "-2.4px",
  margin: "auto",
  fontWeight: 700
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: [2, 2.4],
    medium: 2.5,
    large: [2.5, 3]
  }
}), (0, _css.minWidth)("230em")({
  fontSize: "4.3rem"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  textAlign: "center",
  lineHeight: "37px"
}));

var hr = (0, _glamor.css)({
  border: "none",
  height: "2px",
  backgroundBlendMode: "normal, color",
  backgroundImage: "linear-gradient(-90deg,#2b98f0, #6497bf)",

  display: "flex",
  width: "8rem",
  justifyContent: "center",
  margin: "auto",
  marginTop: "2.5rem",
  marginBottom: "1.65rem"
}, (0, _css.minWidth)(_css.breakpoints.large)({
  width: "10rem",
  margin: "auto",
  marginTop: "2rem",
  marginBottom: "2.8rem",
  display: "block"
}), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: "1.2rem"
}));

var linkWrap = (0, _glamor.css)({
  height: "100%",
  float: "left",
  position: "absolute",
  display: "table",
  background: "#000"
});

var toolsIcons = (0, _glamor.css)({
  marginTop: "1.5em"
});
var toolText = function toolText(fontScale) {
  return (0, _glamor.css)({
    color: "#aaa",
    fontSize: (0, _css.unitRem)(0.45 * fontScale),
    marginTop: "2px",
    top: "-5px",
    position: "relative",
    display: "inline",
    whiteSpace: "nowrap"
  });
};

var toolIcon = (0, _glamor.css)({
  marginLeft: "0.5em",
  position: "relative",
  display: "inline",
  "&:first-child": {
    marginLeft: 0
  },
  "& img": {
    width: 20,
    height: 20
  },
  "&:hover": {
    "& span": {
      display: "block"
    }
  }
});

var toolName = (0, _glamor.css)({
  display: "none",
  position: "absolute",
  borderRadius: "3px",
  top: "-20px",
  fontSize: "13px",
  background: "rgba(0,0,0,0.5)",
  color: "#aaa",
  left: "50%",
  transform: "translateX(-50%)",
  whiteSpace: "nowrap",
  textTransform: "capitalize",
  padding: "0px 4px 1px"
});

var importAll = function importAll(r) {
  return r.keys().map(r);
};

// const getToolIconSrc = tool => R.prop(tool, {
//   'megascans': '/icons/gallery/tools/megascans.png',
//   'vray': '/icons/gallery/tools/vray.png',
//   '3dsmax': '/icons/gallery/tools/3dsmax.jpeg',
//   'unity': '/icons/gallery/tools/unity.jpeg',
//   'ue4': '/icons/gallery/tools/ur42.png',
//   'marmoset-toolbag': '/icons/gallery/tools/marmoset.jpeg',
//   'quixel-suite': '/icons/gallery/tools/suit.png',
//   'zbrush': '/icons/gallery/tools/zbrush.png',
//   'cryengine': '/icons/gallery/tools/cry.png',
//   'photoshop': '/icons/gallery/tools/ps.png',
//   'octane': '/icons/gallery/tools/octane.png',
//   'redshift': '/icons/gallery/tools/redshift.png',
//   'maya': '/icons/gallery/tools/maya.jpg',
//   'worldmachine': '/icons/gallery/tools/wmlogo.jpg',
//   'growfx': '/icons/gallery/tools/growfx.jpeg',
// });

var getTilesPositionData = function getTilesPositionData(galleryData, currentCategory) {
  var defaultRowHeight = Math.floor(windowWidth / 5.7);
  if (defaultRowHeight < 200) {
    defaultRowHeight = 200;
  }

  var rowWidth = 0;
  var rowWidths = [];
  var rows = [];
  var scaledWidth = void 0;
  var row = [];
  var img = void 0;
  // galleryData = PHOTO_SET;
  for (var i = 0; i < galleryData.length; i++) {
    img = galleryData[i];
    if (currentCategory !== "everything" && currentCategory !== img.category) {
      row.push(img);
      continue;
    }
    scaledWidth = img.width * (defaultRowHeight / img.height) + 3;

    if (rowWidth + scaledWidth / 2 > windowWidth) {
      rows.push(row);
      row = [];
      rowWidths.push(rowWidth);
      rowWidth = 0;
    }

    row.push(img);
    rowWidth += scaledWidth;
  }
  if (row.length > 1) {
    rowWidths.push(rowWidth);
    rows.push(row);
  }

  var rowHeights = [];
  var imageData = [];
  var rowHeight = void 0;
  var ratio = void 0;
  var topPos = 0;
  var leftPos = 0;
  var tileWidth = void 0;
  var galleryHeight = 0;
  var imgData = void 0;

  for (var _i = 0; _i < rows.length; _i++) {
    rowHeight = defaultRowHeight;
    if (rowWidths[_i] !== windowWidth) {
      ratio = rowWidths[_i] / windowWidth;
      rowHeight = defaultRowHeight / ratio;
    }

    for (var j = 0; j < rows[_i].length; j++) {
      img = rows[_i][j];
      ratio = rowHeight / img.height;
      tileWidth = img.width * ratio;
      imgData = {
        img: img,
        imageHeight: rowHeight,
        imageWidth: tileWidth,
        topPos: topPos,
        leftPos: leftPos,
        visibility: "1",
        scale: ratio
      };
      if (currentCategory !== "everything" && currentCategory !== img.category) {
        imgData.visibility = "0";
      } else {
        leftPos += tileWidth + 4;
      }
      imageData.push(imgData);
    }
    leftPos = 0;
    topPos += rowHeight + 4;
  }
  console.log(defaultRowHeight);
  if (defaultRowHeight < 300) {
    // defaultRowHeight = 300;
  }
  var fontScale = 1 + (defaultRowHeight - 252) / 300;
  // if(fontScale < 0.7 )fontScale = 0.7;
  return {
    imageData: imageData,
    galleryHeight: topPos,
    fontScale: fontScale
  };
};

var Tile = function (_React$Component) {
  (0, _inherits3.default)(Tile, _React$Component);

  function Tile(props) {
    (0, _classCallCheck3.default)(this, Tile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Tile.__proto__ || (0, _getPrototypeOf2.default)(Tile)).call(this, props));

    _this.getPreviousItem = _this.getPreviousItem.bind(_this);
    _this.getNextItem = _this.getNextItem.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Tile, [{
    key: "getPreviousItem",
    value: function getPreviousItem(itemId) {
      var _this2 = this;

      var imgIndex = parseInt(itemId, 10) - 1;

      return imgIndex < 0 ? null : {
        pathname: "/gallery/" + imgIndex,
        state: {
          modal: true,
          fullScreen: true,

          previousTo: function previousTo() {
            return _this2.getPreviousItem(imgIndex);
          },
          nextTo: function nextTo() {
            return _this2.getNextItem(imgIndex);
          },
          info: { toolIconsFolder: cloudfront("icons/gallery/tools/") }
        }
      };
    }
  }, {
    key: "getNextItem",
    value: function getNextItem(itemId) {
      var _this3 = this;

      var imgIndex = parseInt(itemId, 10) + 1;

      return imgIndex > this.props.totalImages - 1 ? null : {
        pathname: "/gallery/" + imgIndex,
        state: {
          modal: true,
          fullScreen: true,
          previousTo: function previousTo() {
            return _this3.getPreviousItem(imgIndex);
          },
          nextTo: function nextTo() {
            return _this3.getNextItem(imgIndex);
          },
          info: { toolIconsFolder: cloudfront("icons/gallery/tools/") }
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var styles = require("./Gallery.scss");
      var itemIndex = this.props.data.img.index;
      var divStyle = {
        width: this.props.data.imageWidth + "px",
        height: this.props.data.imageHeight + "px",
        transform: "translate(" + this.props.data.leftPos + "px , " + this.props.data.topPos + "px)",
        opacity: this.props.data.visibility
      };
      var loadingImgs = 0;
      // const windowWidth = window.screen.width;
      var windowWidth = window.innerWidth;
      // setTimeout(()=>
      // {
      //   if(this.refImage)
      //   {
      //     this.refImage.src = this.props.data.img.src;
      //   }
      // }, 50*(itemIndex + 1));
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          key: "link" + itemIndex,
          className: linkWrap,
          to: {
            pathname: "/gallery/" + itemIndex,
            state: {
              modal: true,
              fullScreen: true,
              previousTo: function previousTo() {
                return _this4.getPreviousItem(itemIndex);
              },
              nextTo: function nextTo() {
                return _this4.getNextItem(itemIndex);
              },
              info: { toolIconsFolder: cloudfront("icons/gallery/tools/") }
            }
          }
        },
        _react2.default.createElement(
          "div",
          { className: tileStyles, key: itemIndex, style: divStyle },
          _react2.default.createElement("img", {
            src: "data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
            ref: function ref(image) {
              _this4.refImage = image;
            }
          }),
          _react2.default.createElement(
            "div",
            { className: imageDescStyles(this.props.fontScale) },
            _react2.default.createElement(
              "div",
              null,
              this.props.data.img.title ? this.props.data.img.title : "Unnamed Artwork"
            ),
            _react2.default.createElement(
              "div",
              null,
              this.props.data.img.author
            ),
            !!this.props.data.img.tools && this.props.data.img.tools.length > 0 && _react2.default.createElement(
              "ul",
              { className: toolsIcons },
              this.props.data.img.tools.map(function (tool) {
                return _react2.default.createElement(
                  "li",
                  { className: toolIcon, key: tool },
                  _react2.default.createElement("img", { src: cloudfront("icons/gallery/tools/") + tool.toLowerCase() + ".png" })
                );
              })
            )
          )
        )
      );
    }
  }]);
  return Tile;
}(_react2.default.Component);

var cloudfrontIcons = function cloudfrontIcons(path) {
  return "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/" + path;
};

var Grid = function (_React$Component2) {
  (0, _inherits3.default)(Grid, _React$Component2);

  function Grid() {
    (0, _classCallCheck3.default)(this, Grid);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this));

    _this5.onWindowResize = _this5.onWindowResize.bind(_this5);
    _this5.issizing = false;
    return _this5;
  }

  (0, _createClass3.default)(Grid, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!__SERVER__) {
        window.addEventListener("resize", this.onWindowResize);
        windowWidth = window.innerWidth;
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.loaded == false && nextProps.loaded == true || this.props.currentCategory != nextProps.currentCategory) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.onWindowResize);
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      var _this6 = this;

      if (!this.issizing) {
        this.issizing = true;
        setTimeout(function () {
          windowWidth = window.innerWidth;
          _this6.forceUpdate();
          _this6.issizing = false;
        }, 200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      if (!this.props.loaded) {
        return _react2.default.createElement(
          "div",
          { className: loadingSpinnerStyles },
          _react2.default.createElement(_Preloader2.default, null)
        );
      }
      var imagesToLoad = 0;
      var imageIndex = 0;
      var loadImage = function loadImage() {
        var tile = _this7["refImage_" + imageIndex];
        if (tile) {
          imageIndex++;
          imagesToLoad++;
          var img = tile.refImage;
          img.onload = function () {
            this.onload = null;
            this.onerror = null;
            imagesToLoad--;
            loadImage();
          };
          img.onerror = function () {
            this.onload = null;
            this.onerror = null;
            imagesToLoad--;
            loadImage();
          };
          img.src = tile.props.data.img.src;
          if (imagesToLoad < 5) {
            loadImage();
          }
        }
      };

      setTimeout(function () {
        loadImage();
      }, 5);

      var positionData = getTilesPositionData(this.props.galleryData, this.props.currentCategory);
      var imagePositionData = positionData.imageData;
      var fontScale = positionData.fontScale;
      var galleryHeight = positionData.galleryHeight;
      var galleryStyle = {
        height: galleryHeight + "px"
      };
      return _react2.default.createElement(
        "div",
        { id: "grid", key: "grid", className: galleryStyles, style: galleryStyle },
        imagePositionData.map(function (imageData, index) {
          imageData.img.index = index;
          return _react2.default.createElement(Tile, {
            key: index,
            ref: function ref(tile) {
              _this7["refImage_" + index] = tile;
            },
            data: imageData,
            fontScale: fontScale,
            totalImages: imagePositionData.length
          });
        })
      );
    }
  }]);
  return Grid;
}(_react2.default.Component);

var Gallery = (_dec = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _gallery.getGalleryData)());
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    galleryData: state.gallery.data,
    loading: state.gallery.loading,
    loaded: state.gallery.loaded,
    loggedIn: state.auth.loggedIn
  };
}), _dec(_class = _dec2(_class = function (_React$Component3) {
  (0, _inherits3.default)(Gallery, _React$Component3);

  function Gallery() {
    (0, _classCallCheck3.default)(this, Gallery);

    var _this8 = (0, _possibleConstructorReturn3.default)(this, (Gallery.__proto__ || (0, _getPrototypeOf2.default)(Gallery)).call(this));

    _this8.state = {
      currentCategory: "everything",
      categories: [{ name: "Everything", value: "everything", selected: true }, { name: "Games", value: "games" }, { name: "Movies", value: "movies" }, { name: "Visualization", value: "viz" }]
    };
    return _this8;
  }

  (0, _createClass3.default)(Gallery, [{
    key: "onClickCategory",
    value: function onClickCategory(category) {
      var categories = this.state.categories.slice();
      for (var i = 0; i < categories.length; i++) {
        if (categories[i].value === category) {
          categories[i].selected = true;
          this.setState({
            currentCategory: category
          });
        } else {
          categories[i].selected = false;
        }
      }
      this.setState({
        categories: categories
      });
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var props = {
        superIconUrls: [cloudfrontIcons("quixel_logo.png")],
        bg: cf("header/Gallery_Header_5120.jpg"),
        title: "quixel gallery",
        subTitle: "Staff-picked artwork from the Quixel community.",
        artist: "Santi Sánchez"
      };
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "- See what our growing community is up to",
          documentImage: cloudfrontThumbs("page-thumb-gallery.jpg"),
          documentDescription: "The Megascan gallery houses amazing artists' work from around the world. Get inspired by our community creations."
        },
        _react2.default.createElement(
          "div",
          { id: "gallery" },
          _react2.default.createElement(_Hero2.default, (0, _extends3.default)({ newApp: true, gallery: true }, props)),
          _react2.default.createElement(Grid, {
            galleryData: this.props.galleryData,
            loaded: this.props.loaded,
            currentCategory: this.state.currentCategory
          })
        )
      );
    }
  }]);
  return Gallery;
}(_react2.default.Component)) || _class) || _class);
exports.default = Gallery;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Gallery/Gallery.jsx
// module id = 2953
// module chunks = 0